// Development-only logging utility
// Wraps console methods to only log in development mode

// Set to false to disable all console logs
const isDevelopment = false;

export const devLog = {
    error: (...args) => {
        if (isDevelopment) {
            console.error(...args);
        }
    },

    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },

    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },

    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    }
};
